import { render, staticRenderFns } from "./SundryCreditorAttachments.vue?vue&type=template&id=c89c460a"
import script from "./SundryCreditorAttachments.vue?vue&type=script&lang=js"
export * from "./SundryCreditorAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c89c460a')) {
      api.createRecord('c89c460a', component.options)
    } else {
      api.reload('c89c460a', component.options)
    }
    module.hot.accept("./SundryCreditorAttachments.vue?vue&type=template&id=c89c460a", function () {
      api.rerender('c89c460a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sundrycreditor/SundryCreditorAttachments.vue"
export default component.exports